import { FaresState, FaresTypes } from './types';

const INITIAL_STATE: FaresState = {
  fareData: {
    id: '',
    name: '',
    value: 0,
    subsidy: 0,
    validFrom: '',
    description: '',
    otherValues: [],
    transportOperatorId: '',
    createdAt: '',
    updatedAt: '',
    externAvailable: true,
  },
  fareCreated: {
    id: '',
    name: '',
    value: 0,
    subsidy: 0,
    validFrom: '',
    otherValues: [],
    transportOperatorId: '',
    createdAt: '',
    updatedAt: '',
    externAvailable: true,
  },
  currentOperation: 'none',
  fareSelected: {
    id: '',
    name: '',
    value: 0,
    subsidy: 0,
    validFrom: '',
    otherValues: [],
    transportOperatorId: '',
    externAvailable: true,
  },
  faresList: [],
  carFaresList: [],
  totalCount: 0,
  loading: false,
  error: false,
};

function createReducer(initialState = INITIAL_STATE, handlers: any) {
  return function reducer(state = initialState, action: any) {
    // eslint-disable-next-line
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    }
    return state;
  };
}

// List Fares
const listFaresRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  faresList: INITIAL_STATE.faresList,
});

const listFaresSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  faresList: action.payload.faresList,
  totalCount: action.payload.totalCount,
});

const listFaresFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  faresList: INITIAL_STATE.faresList,
});

// List Car Fares
const listCarFaresRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  carFaresList: INITIAL_STATE.carFaresList,
});

const listCarFaresSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  carFaresList: action.payload.carFaresList,
  totalCount: action.payload.totalCount,
});

const listCarFaresFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  carFaresList: INITIAL_STATE.carFaresList,
});

// Filter Fares
const filterFaresRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const filterFaresSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  totalCount: action.payload.totalCount,
});

const filterFaresFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Get Fare
const getFareRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  fareData: INITIAL_STATE.fareData,
});

const getFareSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  fareData: action.payload.fareData,
});

const getFareFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  fareData: INITIAL_STATE.fareData,
});

// Create Fare
const createFareRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
  fareCreated: INITIAL_STATE.fareCreated,
});

const createFareSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  fareCreated: action.payload.fareCreated,
});

const createFareFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
  fareCreated: INITIAL_STATE.fareCreated,
});

// Create Car Fare
const createCarFareRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const createCarFareSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
});

const createCarFareFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Update Fare
const updateFareRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const updateFareSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
  fareData: action.payload.fareData,
});

const updateFareFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Update Car Fare
const updateCarFareRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const updateCarFareSuccess = (state: any, action: any) => ({
  ...state,
  loading: false,
  error: false,
});

const updateCarFareFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Delete Fare
const deleteFareRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const deleteFareSuccess = (state: any) => ({
  ...state,
  loading: false,
  error: false,
});

const deleteFareFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Delete Car Fare
const deleteCarFareRequest = (state: any) => ({
  ...state,
  loading: true,
  error: false,
});

const deleteCarFareSuccess = (state: any) => ({
  ...state,
  loading: false,
  error: false,
});

const deleteCarFareFailure = (state: any) => ({
  ...state,
  loading: false,
  error: true,
});

// Set Current Operation
const setCurrentOperation = (state: any, action: any) => ({
  ...state,
  currentOperation: action.payload.operation,
});

// Set Fare Selected
const setFareSelected = (state: any, action: any) => ({
  ...state,
  fareSelected: action.payload.fareSelected,
});

const reducer = createReducer(INITIAL_STATE, {
  [FaresTypes.LIST_FARES_REQUEST]: listFaresRequest,
  [FaresTypes.LIST_FARES_SUCCESS]: listFaresSuccess,
  [FaresTypes.LIST_FARES_FAILURE]: listFaresFailure,

  [FaresTypes.LIST_CAR_FARES_REQUEST]: listCarFaresRequest,
  [FaresTypes.LIST_CAR_FARES_SUCCESS]: listCarFaresSuccess,
  [FaresTypes.LIST_CAR_FARES_FAILURE]: listCarFaresFailure,

  [FaresTypes.FILTER_FARES_REQUEST]: filterFaresRequest,
  [FaresTypes.FILTER_FARES_SUCCESS]: filterFaresSuccess,
  [FaresTypes.FILTER_FARES_FAILURE]: filterFaresFailure,

  [FaresTypes.GET_FARE_REQUEST]: getFareRequest,
  [FaresTypes.GET_FARE_SUCCESS]: getFareSuccess,
  [FaresTypes.GET_FARE_FAILURE]: getFareFailure,

  [FaresTypes.CREATE_FARE_REQUEST]: createFareRequest,
  [FaresTypes.CREATE_FARE_SUCCESS]: createFareSuccess,
  [FaresTypes.CREATE_FARE_FAILURE]: createFareFailure,

  [FaresTypes.CREATE_CAR_FARE_REQUEST]: createCarFareRequest,
  [FaresTypes.CREATE_CAR_FARE_SUCCESS]: createCarFareSuccess,
  [FaresTypes.CREATE_CAR_FARE_FAILURE]: createCarFareFailure,

  [FaresTypes.UPDATE_FARE_REQUEST]: updateFareRequest,
  [FaresTypes.UPDATE_FARE_SUCCESS]: updateFareSuccess,
  [FaresTypes.UPDATE_FARE_FAILURE]: updateFareFailure,

  [FaresTypes.UPDATE_CAR_FARE_REQUEST]: updateCarFareRequest,
  [FaresTypes.UPDATE_CAR_FARE_SUCCESS]: updateCarFareSuccess,
  [FaresTypes.UPDATE_CAR_FARE_FAILURE]: updateCarFareFailure,

  [FaresTypes.DELETE_FARE_REQUEST]: deleteFareRequest,
  [FaresTypes.DELETE_FARE_SUCCESS]: deleteFareSuccess,
  [FaresTypes.DELETE_FARE_FAILURE]: deleteFareFailure,

  [FaresTypes.DELETE_CAR_FARE_REQUEST]: deleteCarFareRequest,
  [FaresTypes.DELETE_CAR_FARE_SUCCESS]: deleteCarFareSuccess,
  [FaresTypes.DELETE_CAR_FARE_FAILURE]: deleteCarFareFailure,

  [FaresTypes.SET_CURRENT_OPERATION]: setCurrentOperation,
  [FaresTypes.SET_FARE_SELECTED]: setFareSelected,
});

export default reducer;
